// ----------------------------------------------------------------------
// <copyright file="Izenda.LayoutUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var UiState = require('logic/Izenda.UiState');
  var BrowserUtils = require('share/utils/Izenda.BrowserUtils');
  const { isNil } = require('lodash/fp');
  function toggle(element, option) {
    if (element.getAttribute('aria-expanded') === 'false') {
      show(element);
    } else {
      hide(element, option);
    }
  }

  function hide(element, option) {
    element.setAttribute('aria-expanded', 'false');
    !option && $izenda('.izenda-Overlay').attr('aria-expanded', 'false');
  }

  function show(element) {
    element.setAttribute('aria-expanded', 'true');
    $izenda('.izenda-Overlay').attr('aria-expanded', 'true');
  }

  function handleToggle(value, className, option) {
    if (!BrowserUtils.isMobileDevice()) {
      return;
    }

    var element = document.getElementsByClassName(className)[0];

    if (isNil(element)) return;

    switch (value) {
      case true:
        show(element);
        break;
      case false:
        hide(element, option);
        break;
      default:
        toggle(element, option);
    }
  }

  function toggleMiddelPanel(value, option) {
    handleToggle(value, 'izenda-MiddlePanel', option);
  }

  function toggleSideBar(value) {
    handleToggle(value, 'izenda-Sidebar');
  }

  function togglePropertiesEditor(value) {
    handleToggle(value, 'izenda-RightPanel');
    handleToggle(value, 'izenda-PropertiesContainer');
  }

  function toggleIconMenu(value) {
    handleToggle(value, 'izenda-IconMenu');
  }

  function toggleOverlay(value) {
    handleToggle(value, 'izenda-Overlay');
  }

  function toggleTopMenu(value) {
    handleToggle(value, 'izenda-TopMenu-nav');
  }

  module.exports = {
    toggleSideBar: toggleSideBar,
    toggleOverlay: toggleOverlay,
    toggleTopMenu: toggleTopMenu,
    toggleIconMenu: toggleIconMenu,
    toggleMiddelPanel: toggleMiddelPanel,
    togglePropertiesEditor: togglePropertiesEditor
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.LayoutUtils.js